const initialState = () => ({
  agents: []
})

export default initialState
